<ul class="seanceslist">
  @for (seance of this.seancesVocal; track seance) {
<li
    class="seanceslist__item"
    [ngClass]="{
      'seanceslist__item--selected': seance.id === this.selectedSeance
    }"
   
    (click)="this.onSelectSeance(seance)"
  >
    <span>
      {{ seance.langue }} - {{ seance.date_creation | date : "dd/MM/yyyy" }}
    </span>
    <span class="seanceslist__item__count">
      <i class="fa-solid fa-file-text"></i>
      {{ seance.compteur_todo - seance.compteur_done }}
    </span>
  </li>
}
</ul>
